import {BasicManagedFile} from './basicManagedFile'
import {OA_MARK, OA_PROJ} from '../Data/typeDirs'
// import {
//   checkDropboxPath,
//   getDropboxFile
// } from '../Services/dropbox'
import { traverseSource } from '../ControlManager/scripts/utils'


const ARCHDIR = '/Archive'

const wrapval = (val)=>([{_name:val}])

class OAMarker extends BasicManagedFile {
  constructor(data){
    super(data)
    this.ext = 'oa_mark'
    this.typeDir= OAMarker.getTypeDir()
    this.name = data && data._id ? data._id : this._id
    // this.construct(data)
  }

  construct(data){
    super.construct(data)
    this._project = data._project
    this.name = data._id || this._id
    this.oa_id = data.oa_id
    this.version = this.version?this.version:1
    // this._name = data._id
    return this
  }

  serialize(){
    let superSerialized = super.serialize()
    let {_project, oa_id} = this
    return {...superSerialized, _project, oa_id}
  }

  getTree(){
    return this.content.content.oa_data.tree
  }

  updateProjectId(id){
    this.content.content.oa_data.tree.project_id = [{_name:id}]
  }

  static getOASchema(){
      return [
        {name: "id", label: "id",  type:'text'},
        {name: "caption", label: "caption",  type:'text', options:['edit']},
        {name: "created", label: "created",  type:'text'},
        {name: "description", label: "description",  type:'text', options:['edit']},
        {name: "original_filename", label: "original_filename",  type:'text'},
        {name: "project_id", label: "project_id",  type:'text'},
        {name: "rank", label: "rank",  type:'text'},
        {name: "keywords", label: "keywords",  type:'multiselect', options:['single-only', 'edit']},
        {name: "oa_url", label: "oa_url",  type:'text'},

      ]
  }

  async makeMarkerData(ds, projLang){
    // let lang = await ds('db')[LANG].getTyped({name:'Unified Report'})
    // await lang.hydrate(ds('db'))
    // console.log('got a lang ', lang)
    // let dataSchema = [
    //   {name: 'mastercat', label: 'Master Category', type:'dropdown', options:['edit'], source:'language.mastercategories', children:[
    //     {name: 'category', label: 'Category', type:'dropdown', options:['edit'], source:'$parent.categories', children:[
    //       {name: 'subcategory', label: 'Subcategory', type:'dropdown', source:'$parent.subcategories', options:['edit']}
    //     ]}
    //   ]}
    // ]
    // traverseSchema(dataSchema, projlang, {}, (control, src, h)=>{
    //   console.log('control source and heirarchy', control, src, h)
    // })
    let data = {tree:{}}

    traverseSource(projLang, (lineItem, address, parentItem)=>{
      let currentLocation = address.split('.')[address.split('.').length-2]
      if(['subcategories', 'mastercategories', 'categories'].includes(currentLocation)){
        if(currentLocation === 'subcategories'){
          let [num1, num2] = lineItem[`!fullNum`].split('.').slice(1)
          let num = [num1, num2].join('.')
          if(this.getTree().keywords.find(itm=>{
            return itm._mask ===`${num} ${lineItem._mask}`
          })){
            let lineData = {}  
            for(let key in lineItem){
              if(Array.isArray(lineItem[key])) continue
              lineData[key] = lineItem[key]
            }
            data.tree.subcategory = lineData
          }

        }else{
          // let locationKey = currentLocation === 'mastercategories'?'mastercategory':'category'
          
        }

        
      }
     
    })

    console.log('made marker data?', data)
  }

  static getOAMarkerFromOAData(oaData, _project, keywordsList){
    let {caption, id, description, created, original_filename, project_id, rank, keywords} = oaData
    let sizeItem = oaData.sizes.find(itm=>itm.id===1)
    let oa_url = `${sizeItem.http_root}${sizeItem.http_relative_path}`

    return new OAMarker({content:{
      oa_data:{
        tree:{
          caption: wrapval(caption),
          id: wrapval(`${id}`),
          description: wrapval(description),
          created: wrapval(created),
          original_filename: wrapval(original_filename),
          project_id: wrapval(project_id),
          rank: wrapval(rank),
          keywords: keywords.map(itm=>({_name:itm.id, _mask: keywordsList.find(k=>k.id === itm.id ).name})),
          oa_url:wrapval(oa_url)
        },
        schema: OAMarker.getOASchema(),
        source:{}
      }
    }, _project, oa_id:id })
  }

  static getExt(){
    return 'oa_mark'
  }

  static getIndices(){
    return `${BasicManagedFile.getIndices()},_project,oa_id`
  }

  static getTypeDir(){
    return OA_MARK
  }

  async getDropboxPath(repName, ds){
    if(!repName){
      let rep = await ds[OA_PROJ].where({_id:this._project})
      rep = await rep.toArray()
      rep = rep[0]
      repName = rep.dirName
    }
    return `${ARCHDIR}/${OA_PROJ}/${repName}/photos/${this._id}.jpg`
  }

  getOAPath(){
    return this.getTree().oa_url[0]._name
  }

  async getParent(ds){
    return ds[OA_PROJ].get({_id:this._project})
  }

  async putToMetastoryFromOpenAsset(openAsset, dataSource, uploadPhoto, userToken, displayNotif){
    let oa_url = this.getOAPath()
    let parent = await this.getParent(dataSource('remDb'))
    

    let blob = await openAsset.getPhotoFromURL(oa_url)

    await uploadPhoto(`${OA_PROJ}/${parent.dirName}`, this._id, blob, userToken, false, true)
  }

  async remotePutToMetastory(openAsset, proj, simpleUploadImage, userToken){
    let oa_url = this.getOAPath()
    // let parent = await this.getParent(dataSource('db'))
    

    let blob = await openAsset.getPhotoFromURL(`https:${oa_url}`)
    let dbxPath = await this.getDropboxPath(proj.dirName)
    await simpleUploadImage(dbxPath, blob)
  }

  // async remotePutToOpenAsset(openAsset, projName){
  //   let name = await this.getDropboxPath(projName)
  //   let photoBlob = await getDropboxFile(name)
  //   // console.log('dbx download success')
  //   let data = this.getDataForOpenAsset()
  //   console.log('got data', data, photoBlob)
  //   let oaUploadRes = await openAsset.uploadPhoto(data, photoBlob.fileBinary)
  //   // console.log('oa upload', oaUploadRes)
  //   return oaUploadRes
  // }

  getDataForOpenAsset(){
    let tree = this.getTree()
    // console.log('getting tree', tree)
    let obj = {}
    for(let key in tree){
      // console.log('looking at prop', tree[key])
      if(['id', 'created', 'oa_url'].includes('key')) continue
      if(key === 'project_id'){
        console.log('project id', tree[key])
      }
      // content = tree[key] || tree[key].content
      if(Array.isArray(tree[key])){
        if(key === 'keywords'){
          obj[key] = tree[key].map(itm=>({id:itm._name}))
          continue
        }

        obj[key] = tree[key][0]._name 
      }else obj[key] = tree[key]
    }
    obj.original_filename = `${this._id}.jpg`
    obj.category_id = 1
    return obj
  }

  // async isPhotoOnDropbox(repName, ds){
  //   let path = await this.getDropboxPath(repName, ds)
  //   return await checkDropboxPath(path)
  // }

  static async delete(fileModels, _id){
    let {Main, Versions} = fileModels[OA_MARK]
    try{
      await Main.findOneAndDelete({_id}).exec()
      await Versions.deleteMany({_parentId:_id}).exec()
    }catch(e){
      console.log('failed deleting report marker', _id, e)
    }
  
  }



  
  getOACreatedDateString(){
    let oaDate = this.getTree().created.content[0]._name
    let year = oaDate.slice(0, 4)
    let month = `${parseInt(oaDate.slice(4, 2))-1}`
    let day = oaDate.slice(6, 2)
    let hour = oaDate.slice(8, 2)
    let min = oaDate.slice(10, 2)
    let sec = oaDate.slice(12)
    let date = new Date(year, month, day, hour, min, sec)

    return date.toLocaleString()

  }

  //
  // getLocalPath(locRoot, repName){
  //   return `${locRoot}/${REP_MARK}/${repName}/${PHOTOS_SM}/${this._id}_sm.jpg`
  // }
  //
  // getRootlessPath(repName){
  //   return `${REP_MARK}/${repName}/${PHOTOS_SM}/${this._id}_sm.jpg`
  // }
  // async getParent(ds){
  //   return await ds[REP].get({_id:this._report})
  // }
  //

  //
  // static async archive(fileModels, _id, repMarkToArchive){
  //   let {Main, Archive, Versions} = fileModels[REP_MARK]
  //
  //   let repMarkArchiveCreateRes,
  //     repMarkVersionsDeleteManyRes,
  //     repMarkDeleteSelfRes
  //
  //   try{
  //     // console.log('do i need repMarkToArchive?', repMarkToArchive)
  //     if(!repMarkToArchive) repMarkToArchive = await Main.findOne({_id}).exec()
  //     console.log('got repMarkToArchive', repMarkToArchive)
  //     repMarkArchiveCreateRes = await Archive.findOneAndUpdate({_id}, repMarkToArchive, {upsert:true}).exec()
  //     console.log('got repMarkArchiveCreateRes')
  //     repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
  //     console.log('got repMarkVersionsDeleteManyRes')
  //     repMarkDeleteSelfRes = await Main.deleteOne({_id}).exec()
  //     console.log('got repMarkDeleteSelfRes')
  //   }catch(e){
  //     console.log( 'failed archiving repMark',
  //       repMarkArchiveCreateRes,
  //       repMarkVersionsDeleteManyRes,
  //       repMarkDeleteSelfRes,
  //       e
  //     )
  //   }
  //   return repMarkToArchive
  // }
  //
  // static async delete(fileModels, _id, repMarkToDelete){
  //   let {Main, Delete, Versions} = fileModels[REP_MARK]
  //
  //   let repMarkDeleteCreateRes,
  //     repMarkVersionsDeleteManyRes,
  //     repMarkDeleteSelfRes
  //
  //   try{
  //     // console.log('do i need repMarkToDelete?', repMarkToDelete)
  //     if(!repMarkToDelete) repMarkToDelete = await Main.findOne({_id}).exec()
  //     console.log('got repMarkToDelete', repMarkToDelete)
  //     // repMarkDeleteCreateRes = await Delete.findOneAndUpdate({_id}, repMarkToDelete, {upsert:true}).exec()
  //     // console.log('got repMarkDeleteCreateRes')
  //     repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
  //     console.log('got repMarkVersionsDeleteManyRes')
  //     repMarkDeleteSelfRes = await Main.deleteOne({_id}).exec()
  //     console.log('got repMarkDeleteSelfRes')
  //   }catch(e){
  //     console.log( 'failed delete repMark',
  //       repMarkDeleteCreateRes,
  //       repMarkVersionsDeleteManyRes,
  //       repMarkDeleteSelfRes,
  //       e
  //     )
  //   }
  //   return repMarkToDelete
  // }
  //
  //
  // static async unarchive(fileModels, _id, repMarkToUnarchive){
  //   let {Main, Archive, Versions} = fileModels[REP_MARK]
  //
  //   let repMarkUnarchiveCreateRes,
  //     // repMarkVersionsDeleteManyRes,
  //     repMarkDeleteSelfRes
  //
  //   try{
  //     // console.log('do i need repMarkToArchive?', repMarkToArchive)
  //     if(!repMarkToUnarchive) repMarkToUnarchive = await Archive.findOne({_id}).exec()
  //     console.log('got repMarkToUnarchive', repMarkToUnarchive)
  //     repMarkUnarchiveCreateRes = await Main.findOneAndUpdate({_id}, repMarkToUnarchive, {upsert:true}).exec()
  //     console.log('got repMarkUnarchiveCreateRes')
  //     // repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
  //     // console.log('got repMarkVersionsDeleteManyRes')
  //     repMarkDeleteSelfRes = await Archive.deleteOne({_id}).exec()
  //     console.log('got repMarkDeleteSelfRes')
  //   }catch(e){
  //     console.log( 'failed archiving repMark',
  //       repMarkUnarchiveCreateRes,
  //       repMarkDeleteSelfRes,
  //       e
  //     )
  //   }
  //   return repMarkToUnarchive
  // }
  //
  // static async killLocalDBRecords(localdb, _id){
  //   let res = await localdb[REP_MARK].kill({_id})
  //   console.log('killing db record for repMarker', _id, res)
  //   return res
  // }
}

export default OAMarker
